import { MIN_LOAN_AMOUNT } from '@repo/shared/constants';
import { providerPreLimitValues } from './provider-pre-limit-values';
export var hasUserLessThan3000Prelimit = function (merchantResponseData, provider) {
    var preLimitValues = providerPreLimitValues(merchantResponseData, provider);
    return preLimitValues ? preLimitValues.max < MIN_LOAN_AMOUNT : false;
};
